<script>
  import { Card, CardBody, CardTitle } from "sveltestrap";

  import { Link } from "svelte-routing";
</script>

<Card>
  <CardBody>
    <CardTitle class="mb-5 h4">Activity</CardTitle>
    <ul class="verti-timeline list-unstyled">
      <li class="event-list active">
        <div class="event-timeline-dot">
          <i class="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
        </div>
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <h5 class="font-size-14">
              22. 12. 18.{" "}
              <i
                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
              />
            </h5>
          </div>
          <div class="flex-grow-1">
            <div>KLAID 2022 Challenge - 모델 제출 마감</div>
          </div>
        </div>
      </li>

      <li class="event-list">
        <div class="event-timeline-dot">
          <i class="bx bx-right-arrow-circle font-size-18" />
        </div>
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <h5 class="font-size-14">
              22. 12. 4.{" "}
              <i
                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
              />
            </h5>
          </div>
          <div class="flex-grow-1">
            <div id="activitytext">
              KLAID 2022 Challenge - 참가 신청 마감 <br/><Link
                to="challenge">상세 정보</Link
              >
            </div>
          </div>
        </div>
      </li>
      <li class="event-list">
        <div class="event-timeline-dot">
          <i class="bx bx-right-arrow-circle font-size-18" />
        </div>
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <h5 class="font-size-14">
              22. 11. 14.{" "}
              <i
                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
              />
            </h5>
          </div>
          <div class="flex-grow-1">
            <div>KLAID 2022 공개</div>
          </div>
        </div>
      </li>
      <li class="event-list">
        <div class="event-timeline-dot">
          <i class="bx bx-right-arrow-circle font-size-18" />
        </div>
        <div class="d-flex">
          <div class="flex-shrink-0 me-3">
            <h5 class="font-size-14">
              22. 1. 13{" "}
              <i
                class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
              />
            </h5>
          </div>
          <div class="flex-grow-1">
            <div>KLAID 2022 데이터셋 기준 일자</div>
          </div>
        </div>
      </li>
    </ul>
  </CardBody>
</Card>
